const getClassName = (
  styles: Record<string, string>,
  baseClassName: string,
  modifier?: string,
) => {
  const getModifiers = (mod: string) => mod.split(' ')
    .map(modifierStr => styles[`${baseClassName}_${modifierStr}`])
    .join(' ')
    .trim();

  return modifier ? `${styles[baseClassName]} ${getModifiers(modifier)}` : `${styles[baseClassName]}`;
};

export default getClassName;
